<ng-container [ngSwitch]="cardVariant?.kind">
  <app-activity-card
    *ngSwitchCase="'activity'"
    [cardModel]="cardModel"
    [isMandatory]="activityVariant!.isMandatory"
    [isCustom]="activityVariant!.isCustom"
    [controls]="controls"
    [cardSelected]="cardSelected"
    [dragDisabled]="dragDisabled"
    [dragStartDelay]="dragStartDelay"
    [editMode]="editMode"
    (cardAction)="cardAction.emit($event)"
    (userAttributes)="userAttributes.emit($event)"
  ></app-activity-card>
  <app-safety-card
    *ngSwitchCase="'safety'"
    [cardModel]="cardModel"
    [category]="safetyVariant!.category"
    [isCustom]="safetyVariant!.isCustom"
    [controls]="controls"
    [cardSelected]="cardSelected"
    [dragDisabled]="dragDisabled"
    [dragStartDelay]="dragStartDelay"
    [editMode]="editMode"
    (cardAction)="cardAction.emit($event)"
    (userAttributes)="userAttributes.emit($event)"
  ></app-safety-card>
  <div
    *ngSwitchCase="'placeholder'"
    class="card-placeholder"
    [class.activity]="placeholderKind === 'activity'"
    [class.safety]="placeholderKind === 'safety'"
    (click)="cardAction.emit({ action: 'clicked' })"
  ></div>
  <div *ngSwitchCase="'empty'"></div>
</ng-container>
